import React from 'react';
import { Helmet } from 'react-helmet';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
import PageWrapper from 'components/PageWrapper';
import { ADMIN } from 'components/RoleGate/constants';
import RoleButton from 'components/RoleButton';
import {
    CREATE_MODAL_QUERY_STRING_PARAM,
    DELETE_MODAL_QUERY_STRING_PARAM
} from 'components/VirtualizedTable/constants';
import SaveMessage from 'components/SaveMessage';
import {
    FERTILIZER_PRODUCT_CREATE_NAMESPACE,
    FERTILIZER_PRODUCT_DELETE_NAMESPACE,
    FERTILIZER_PRODUCT_UPDATE_NAMESPACE
} from 'services/fertilizerProducts/constants';
import SingleActiveTableRowGate from 'components/SingleActiveTableRowGate';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import { MdDelete } from 'react-icons/md';
import FertilizerProductsVirtualizedTable from './components/FertilizerProductsVirtualizedTable';

const { REACT_APP_PROJECT_NAME } = process.env;

const FertilizerProducts = (): React.ReactElement => (
    <ErrorBoundary
        namespace="FertilizerProducts"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>Products - {REACT_APP_PROJECT_NAME}</title>
        </Helmet>
        <PageTitleAndFilters
            title="Fertilizer Products"
            searchInputPlaceholder="Search"
            hideFilters
            FirstActionButton={
                <SingleActiveTableRowGate>
                    <RoleButton
                        requiredRoles={[ADMIN]}
                        params={{
                            [DELETE_MODAL_QUERY_STRING_PARAM]: true
                        }}
                        buttonProps={{
                            icon: true,
                            color: 'black',
                            basic: true,
                            style: {
                                marginRight: 0,
                                marginLeft: 8
                            }
                        }}
                    >
                        <ButtonIconWrapper>
                            <MdDelete
                                style={{
                                    fontSize: 20
                                }}
                            />
                        </ButtonIconWrapper>
                        Delete
                    </RoleButton>
                </SingleActiveTableRowGate>
            }
            SecondActionButton={
                <RoleButton
                    requiredRoles={[ADMIN]}
                    params={{
                        [CREATE_MODAL_QUERY_STRING_PARAM]: true
                    }}
                    buttonProps={{
                        secondary: true,
                        style: {
                            marginRight: 0,
                            marginLeft: 8
                        }
                    }}
                >
                    Create New
                </RoleButton>
            }
            MessageComponent={
                <SaveMessage
                    namespace={[
                        FERTILIZER_PRODUCT_CREATE_NAMESPACE,
                        FERTILIZER_PRODUCT_UPDATE_NAMESPACE,
                        FERTILIZER_PRODUCT_DELETE_NAMESPACE
                    ]}
                />
            }
        />
        <PageWrapper top={0} bottom={50}>
            <PageTitleAndFiltersPusher>
                <FertilizerProductsVirtualizedTable tableId="fertilizerProducts" />
            </PageTitleAndFiltersPusher>
        </PageWrapper>
    </ErrorBoundary>
);

export default FertilizerProducts;
